import styled, { css } from 'styled-components'

import { TypeStyle, fromMd, untilMd } from '@syconium/little-miss-figgy'
import { FigsLoader } from '@syconium/little-miss-figgy'

import { Body as PageTabSectionBody } from '../../page-sections/PageTabSection/styles'
import { Slider as TileLayoutSlider } from '../../TileLayout/styles'

export const tileAspectRatioPadding = '130%'
export const tileMarginBottom = '32px'

export const LoadMoreProductsButton = styled.button`
  background-color: ${o => o.theme.color.deprecated.stoneLighter};
  display: block;
  height: 103px;
  margin: auto;
  max-width: 557px;
  outline: none;
  width: 100%;
`

export const ProductsLoadedText = styled(TypeStyle.BodyNano)`
  color: ${o => o.theme.color.deprecated.obsidianLighter};
  margin-top: 8px;
`

export const BackToTopButton = styled.button`
  display: block;
  margin: ${o => o.theme.spacing(2.5)} auto 0;
`

export const BackToTopText = styled(TypeStyle.BodyNano)`
  text-decoration: underline;
`

export const StyledFigsLoader = styled(FigsLoader)`
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  margin-top: ${o => o.theme.spacing(6)};
  margin-bottom: ${o => o.theme.spacing(8.75)};
  ${fromMd} {
    margin-bottom: ${o => o.theme.spacing(17.5)};
  }
`

export const CollectionPageTabSectionWrapper = styled.div<{ index: number }>`
  * {
    ::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  ${o =>
    o.index > 0 &&
    css`
      ${PageTabSectionBody} {
        margin-bottom: 0;
      }
      ${untilMd} {
        ${TileLayoutSlider} {
          padding-bottom: 4px;
        }
      }

      ${fromMd} {
        ${PageTabSectionBody} {
          margin-bottom: 24px;
        }
      }
    `}
`
